import React, { PureComponent } from 'react';
import { ToastContainer } from 'react-toastify';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from './assets/styles.scss';

import IconClose from '../../components/Modal/assets/close.svg?inline';

const cx = classNames.bind(styles);

function CloseButton({ closeToast }) {
  return (
    <button type="button" onClick={closeToast}>
      <IconClose />
    </button>
  );
}

CloseButton.propTypes = {
  closeToast: PropTypes.func,
};

CloseButton.defaultProps = {
  closeToast: () => {},
};

export default class Toast extends PureComponent {
  render() {
    return (
      <ToastContainer
        hideProgressBar
        className={cx('toast-container')}
        position="top-right"
        autoClose={5000}
        newestOnTop
        closeOnClick
        pauseOnVisibilityChange
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        closeButton={<CloseButton />}
      />
    );
  }
}
